var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "@widget/popups/Modal";
import { ObjectSearchComponent } from "@widget/list/Tables/object-search/ObjectSearchComponent";
/**
 * @export
 * A large filterable list-picker modal wrapping the existing ObjectSearchComponent.
 * Single-select: clicking a row returns it and closes the modal (v4 popupsearch parity).
 *
 * @category Overlays
 */
const SearchListModal = (props) => {
    const { isOpen, onClose, onSelect, modalTitle, title } = props, oscProps = __rest(props, ["isOpen", "onClose", "onSelect", "modalTitle", "title"]);
    return (_jsx(Modal, { show: isOpen, onClose: onClose, title: modalTitle || (typeof title === 'string' ? title : undefined), className: "uxpcore_search-modal", children: _jsx("div", { className: "uxpcore_search-modal__body", children: _jsx(ObjectSearchComponent, Object.assign({}, oscProps, { onClickRow: (e, item) => { onSelect(item); onClose(); } })) }) }));
};
export default SearchListModal;
